import {
  WitboostCommercialModule,
  mergeArraysWithEmptyCheck,
} from '@agilelab/plugin-wb-platform-common';

/**
 * Returns the required commercial modules to enable the "User configurations" section.
 * Empty array means no restrictions (visible by default).
 */
export const getUserConfigsRequiredModules = (): WitboostCommercialModule[] => {
  return [WitboostCommercialModule.ControlPlane];
};

/**
 * Returns the required commercial modules to enable the "User headers" section.
 * Empty array means no restrictions (visible by default).
 */
export const getUserHeadersRequiredModules = (): WitboostCommercialModule[] => {
  return [
    WitboostCommercialModule.ControlPlane,
    WitboostCommercialModule.MarketPlane,
  ];
};

/**
 * Returns the required commercial modules to enable the Advanced tab itself.
 * It merges the requirements of its inner sections so that the tab is visible
 * if at least one child section would be visible.
 */
export const getAdvancedRequiredModules = (): WitboostCommercialModule[] => {
  return mergeArraysWithEmptyCheck(
    getUserConfigsRequiredModules(),
    getUserHeadersRequiredModules(),
  );
};
